import React, { HtmlHTMLAttributes, ImgHTMLAttributes, ReactElement, ReactNode, useState } from "react";

export function Image(props: ImgHTMLAttributes<HTMLImageElement> & {fallback?: ReactElement}){
    const [error, setError] = useState(false)
    if(error)
        return props.fallback;

    return <img {...props} onError={() => setError(true)} />
}